/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import './styles.scss';
import logo from '../../assets/navbar/logo.png';
import profile from '../../assets/navbar/profile-icon.svg';

class Navbar extends Component {
  // https://codesandbox.io/s/friendly-hofstadter-qtrtn?file=/src/index.js:235-433
  handleClick = () => {
    if (!this.props.profileOpen) {
      document.addEventListener('mousedown', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('mousedown', this.handleOutsideClick, false);
    }
    this.props.toggleProfile(!this.props.profileOpen);
  }

  handleOutsideClick = (e) => {
    if (this.props.profileOpen && this.node && !this.node.contains(e.target) && this.node2 && !this.node2.contains(e.target)) this.handleClick();
  };

  switchUserType = async (userTypeId) => {
    if (this.props.userType !== userTypeId) {
      await this.props.setUserType(userTypeId);
      this.props.switchUserType(userTypeId);
      this.props.toggleProfile(false);
      await this.props.getUserData();
      this.props.history.push('/');
    }
  }

  editUserType = async (e, userTypeId) => {
    e.stopPropagation();
    this.props.history.push('/survey');
    this.props.switchUserType(userTypeId);
    await this.props.setUserType(userTypeId);
    this.props.toggleProfile(false);
    await this.props.getUserData();
  }

  render() {
    return (
      <>
        <nav className="navbar">
          <ul>
            <div>
              <li><NavLink to="/landing" exact activeClassName="navbar-active"> <img className="logo" src={logo} alt="navbarLogo" /></NavLink></li>
              {this.props.authenticated && !this.props.done
                ? <li><NavLink to="/survey" activeClassName="navbar-active"> Survey </NavLink></li>
                : null
              }
              {this.props.authenticated && this.props.done ? [
                <li key="profile" id="profile" onClick={() => this.props.goToProfile(this.props.history)}><NavLink to="/profile" activeClassName="navbar-active">Profile</NavLink></li>,
                <li key="feed"><NavLink to="/feed" activeClassName="navbar-active"> Feed </NavLink></li>,
                <li key="matches"><NavLink to="/matches" activeClassName="navbar-active"> Matches </NavLink></li>,
              ] : null}
              {this.props.location.pathname === '/feed' ? (
                <input
                  type="text"
                  id="search-bar"
                  placeholder={this.props.userType === 1
                    ? 'Search by name or email'
                    : 'Search by name, email, or location'}
                  onKeyPress={async (e) => {
                    try {
                      if (e.key === 'Enter') e.target.blur();
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                  onBlur={async (e) => {
                    try {
                      const filter = await this.props.updateFilter('search', e.target.value, this.props.filter);
                      await this.props.getUsers(filter);
                      const promises = Object.entries(this.props.users).map(([email, user]) => {
                        return this.props.getProfilePhoto(
                          user.answers?.profile_photo?.answer,
                          email,
                        );
                      });
                      await Promise.all(promises);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                />
              ) : null}
            </div>
            <div>
              {this.props.authenticated
                ? (
                  <div
                    className="nav-profile-link"
                    onClick={this.handleClick}
                    ref={(node) => { this.node2 = node; }}
                  >
                    <p>{this.props.name}</p>
                    <img src={profile} alt="profile" />
                  </div>
                )
                : [
                  <li key="login"><NavLink to="/login" activeClassName="navbar-active"> Sign In </NavLink></li>,
                  <li key="register"><NavLink to="/register" activeClassName="navbar-active"> Sign Up </NavLink></li>,
                ]
             }
            </div>
          </ul>
        </nav>
        { (this.props.profileOpen && this.props.authenticated)
        && (
        <div className="profile-menu" ref={(node) => { this.node = node; }}>
          <h5><b>{this.props.name}: </b>{this.props.userType === 1 ? 'On campus' : 'Off campus'}</h5>
          <hr />
          <p
            id="on-campus-button"
            className={this.props.userType === 1 ? 'profile-menu-selected' : ''}
            onClick={() => this.switchUserType(1)}
          >On campus
            <div
              id="on-campus-edit-button"
              className="editButton"
              onClick={e => this.editUserType(e, 1)}
            >edit
            </div>
          </p>
          <p
            id="off-campus-button"
            className={this.props.userType === 2 ? 'profile-menu-selected' : ''}
            onClick={() => this.switchUserType(2)}
          >Off campus
            <div
              id="off-campus-edit-button"
              className="editButton"
              onClick={e => this.editUserType(e, 2)}
            >edit
            </div>
          </p>
          <hr />
          <p
            id="logout"
            onClick={() => {
              this.props.toggleProfile(false);
              this.props.logOut();
            }}
          >
            Sign out
          </p>
        </div>
        )
      }
      </>
    );
  }
}

export default Navbar;
